import { ChartCardWithWidget } from 'src/components/overview/ChartCard'
import OrdersBreakDownTable from 'src/components/overview/charts/OrdersSection/OrdersBreakdownTable'
import OrdersChart from 'src/components/overview/charts/OrdersSection/OrdersChart'
import SalesBreakDownByUTMPieChart from 'src/components/overview/charts/OrdersSection/SalesBreakDownByUTMPieChart'
import SalesBreakDownTable from 'src/components/overview/charts/OrdersSection/SalesBreakdownTable'
import { CheckWidget } from 'src/components/overview/charts/common/CheckWidget'
import { WidgetId, WidgetSections } from 'src/lib/contexts/AnalyticsContext/types'

const OrdersSection = () => {
  return (
    <div>
      {/* Charts */}
      <div className='space-y-6'>
        {/* Single Series Line Chart */}
        <div className='grid grid-cols-2 gap-4'>
          {/* Comparison Line Chart */}
          <CheckWidget widgetId={WidgetId.orders}>
            <ChartCardWithWidget widgetSection={WidgetSections.orders} widgetId={WidgetId.orders}>
              <OrdersChart dataKey='order_completed_count' />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.orders_breakdown}>
            <ChartCardWithWidget widgetSection={WidgetSections.orders} widgetId={WidgetId.orders_breakdown}>
              <OrdersBreakDownTable />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.orders_sales}>
            <ChartCardWithWidget widgetSection={WidgetSections.orders} widgetId={WidgetId.orders_sales}>
              <OrdersChart dataKey='total_gmv' isCurrency />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.orders_sales_breakdown}>
            <ChartCardWithWidget widgetSection={WidgetSections.orders} widgetId={WidgetId.orders_sales_breakdown}>
              <SalesBreakDownTable />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.orders_average_order_value}>
            <ChartCardWithWidget widgetSection={WidgetSections.orders} widgetId={WidgetId.orders_average_order_value}>
              <OrdersChart dataKey='aov' isCurrency />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.orders_sales_breakdown_by_utm}>
            <ChartCardWithWidget
              widgetSection={WidgetSections.orders}
              widgetId={WidgetId.orders_sales_breakdown_by_utm}
            >
              <SalesBreakDownByUTMPieChart />
            </ChartCardWithWidget>
          </CheckWidget>
        </div>
      </div>
    </div>
  )
}

export default OrdersSection
